export default __webpack_public_path__ + "static/media/mastercard.73f85dd0.svg";